/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');



window.Vue = require('vue');
import VueRouter from 'vue-router';



Vue.use(VueRouter);

import Lang from 'lang.js';

const default_locale = window.default_language;
const fallback_locale = window.fallback_locale;

Vue.prototype.trans = new Lang( { messages: window.messages, locale: default_locale, fallback: fallback_locale } );
Vue.prototype.currentLocale =  default_locale;
window.trans = Vue.prototype.trans;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('info-client-modal',require('./components/clientinfo/clientInfoButtonAndModal.vue').default);
Vue.component('sites-list-map', require('./components/sitesListMap.vue').default);
Vue.component('site-project-map',require('./components/sitesprojectMap.vue').default);

Vue.component('add-site-google-map',require('./components/addSiteGMap.vue').default);
Vue.component('google-map-site', require('./components/googleMapSite.vue').default);
Vue.component('module-eco',require('./components/moduleEco.vue').default);
Vue.component('export-modal',require('./components/export/exportButtonAndModal.vue').default);
Vue.component('import-plan-modal',require('./components/maps/importPlan/importPlanButtonAndModal.vue').default);

Vue.component('edit-building-google-map', require('./components/zones/editBuildingGoogleMap.vue').default);
Vue.component('add-building-user-gmap',require('./components/addBuildinguserGmap.vue').default);
Vue.component('delete-zone-modal',require('./components/zones/delete/deleteZoneButtonAndModal.vue').default);

Vue.component('add-pv-fields-modal',require('./components/pvfields/addPvFieldsButtonAndModal.vue').default);
Vue.component('delete-pv-fields-modal',require('./components/pvfields/delete/deletePvFieldsButtonAndModal.vue').default);

Vue.component('create-questionnaire',require('./components/createQuestionnaire.vue').default);
Vue.component('show-questionnaire',require('./components/showQuestionnaire.vue').default);
Vue.component('formulaire',require('./components/formulaire.vue').default);

Vue.component('capex-opex',require('./components/capexopex.vue').default);
Vue.component('coeffcountry',require('./components/coeffcountry.vue').default);
Vue.component('exportconfig',require('./components/exportConfig.vue').default);
Vue.component('squareColor',require('./components/squareColor.vue').default);

Vue.component('simulraccobuttonmodal',require('./components/simulRacco/simulRaccoButtonModal.vue').default);

Vue.component('chartPatrimonies',require('./components/patrimonies/charts/chartPatrimonies.vue').default);
Vue.component('charts-patrimonie-setup',require('./components/patrimonies/charts/graphPatrimoniesSetup.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
 
const app = new Vue({
    el: '#app',
});
